import * as Sentry from '@sentry/react';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import AppLayout from '../common/Layout/AppLayout';
import { ErrorBoundary } from '../error';
// import MobileUI from '../MobileUi';
import MobileScreen from '../Onboarding/MobileScreen';
import PrivateRoute from './PrivateRoute';
import { useMediaQuery } from '@mui/material';

const AppPrivateRoute = ({ children, ...rest }) => {
  const { pathname } = useLocation();
  // const [isMobile, setIsMobile] = useState();
  // const [isLoading, setIsLoading] = useState(false);
  // const isMatch = useMediaQuery(theme.breakpoints.down('xs'));
  // const isMobile =
  //   'maxTouchPoints' in navigator && navigator.maxTouchPoints > 0;
  // const isMobile =
  //   useMediaQuery('(max-width: 768px)') &&
  //   'maxTouchPoints' in navigator &&
  //   navigator.maxTouchPoints > 0;
  const isMobile = useMediaQuery('(max-width: 768px)');

  const path = '/business-registration';
  const userChoice = sessionStorage.getItem('chooseWeb');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  // useEffect(() => {
  //   setIsLoading(true);
  //   const handleResize = () => {
  //     if (window.innerWidth < 1065 && pathname !== '/business-registration') {
  //       setIsMobile(true);
  //       setIsLoading(false);
  //     } else {
  //       setIsMobile(false);
  //       setIsLoading(false);
  //     }
  //   };
  //   handleResize();
  // }, []);

  // if (isLoading) return <></>;

  const privateRouteProps = { ...rest, pathname };
  return (
    <PrivateRoute {...privateRouteProps}>
      {process.env.NODE_ENV !== 'development' ? (
        <Sentry.ErrorBoundary
          fallback={({ error, componentStack, resetError }) => (
            <React.Fragment>
              <ErrorBoundary />
            </React.Fragment>
          )}
        >
          {isMobile && pathname !== path && userChoice !== 'yes' ? (
            <MobileScreen />
          ) : (
            <AppLayout>{children}</AppLayout>
          )}
        </Sentry.ErrorBoundary>
      ) : (
        <ErrorBoundary>
          {isMobile && pathname !== path && userChoice !== 'yes' ? (
            <MobileScreen />
          ) : (
            <AppLayout>{children}</AppLayout>
          )}
        </ErrorBoundary>
      )}
    </PrivateRoute>
  );
};

export default AppPrivateRoute;
